import { BaseResponse } from 'src/types'
import { getEndpoint } from '.'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

export const deleteOperationDetail = (idOperacion: number, idOperationDetail: number): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${idOperacion}/detalles/${idOperationDetail}`)

    return HttpAxiosRequest.delete(endpoint)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
